<template>
  <div class="card card-body p-0 mb-3">
    <div class="table-responsive">
      <div class="text-end fw-bold mx-3">
        Number of rows:
        {{ numberOfEntries }}
      </div>
      <table class="table table-striped m-0 text-start" aria-label="Admin">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col" class="text-end">Last Updated</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in entries" :key="entry.id">
            <td>{{ entry.fullname }}</td>
            <td class="text-end">{{ entry.tsUpdatedLabel }}</td>
            <td class="text-end">
              <button class="btn btn-danger" @click="resetUsersData(entry)">
                Reset Data
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DatastoreAPI from "@/helpers/DatastoreAPI";

/*
 * If you need to display specific data properties,
 * you can add in new <td> with `entry.value`, for example.
 */
export default {
  name: "AdminTable",
  props: {
    entries: Array
  },
  mixins: [DatastoreAPI],
  computed: {
    numberOfEntries() {
      return this.entries?.length;
    }
  },
  methods: {
    resetUsersData(entry) {
      console.log("Reset users data", entry);
      // Call the deleteEntry method with the entry to be deleted
      this.deleteEntry(entry, () => {
        // Optionally, you can perform additional actions after the entry is deleted
        console.log("Entry deleted successfully!");
        // For example, you may want to refresh the list of entries after deletion
        this.readEntries();
      });
    }
  }
};
</script>
